import type { RouteLocationNormalizedGeneric } from '#vue-router'

import { useTeamsStore } from '@pages/users'
import { MAX_PER_PAGE, getFirstQueryValue, toPaginationValue } from '@shared/lib/routes'

import { defineNuxtRouteMiddleware } from '#app'

/**
 * `/users/teams` — query → store filters, mirroring `middleware/users.ts`. `page` / `per_page` are
 * also validated off the query by `useTeamsApi` (query wins for those two); mirrored here so a deep
 * link leaves the store agreeing with what was requested.
 */
export default defineNuxtRouteMiddleware((to: RouteLocationNormalizedGeneric) => {
  const store = useTeamsStore()

  store.setFilterSearch(getFirstQueryValue(to.query?.q) || null)
  store.setCurrentPage(toPaginationValue(to.query?.page, 1))
  store.setPerPage(toPaginationValue(to.query?.per_page, store.getPerPage, MAX_PER_PAGE))
})
